<template>
  <div>
    <vue-autosuggest
      v-model="query"
      style="width: 100%"
      :suggestions="filteredOptions"
      :get-suggestion-value="getSuggestionValue"
      :input-props="{
        id: 'autosuggest__input',
        class: 'form-control',
        placeholder: 'Cari Adı'
      }"
      @input="onInputChange"
    >
      <template slot-scope="{ suggestion }">
        <div class="d-flex align-items-center my-suggestion-item">
          <div class="detail ml-50 my-suggestion-item">
            <b-card-text class="mb-0">
              {{ suggestion.item.ACTNAME }}
            </b-card-text>
          </div>
        </div>
      </template>
    </vue-autosuggest>
  </div>
</template>
<script>
import Store from "../../../../store/store";
import state from "../../../../store/state";
export default {
  data() {
    return {
      query: "",
      filteredOptions: [],
      data: "",
      ACTID: "",
      ACTSTOCKGROUP: "",
      ACTNAME: ""
    };
  },
  created() {
    this.setData(this.params.value === "Happy");
    this.query = this.params.data.ACTNAME;
    this.setData(this.query);
    this.$store.commit("account/SATINALMA_ACTID", this.params.data.ACTID);
  },
  methods: {
    getValue() {
      return this.data;
    },
    setData(data) {
      this.data = data;
    },
    getSuggestionValue(suggestion) {
      console.log(suggestion);
      console.log(this.params.data);

      this.ACTNAME = suggestion.item.ACTNAME;
      this.ACTID = suggestion.item.ACTID;
      this.ACTSTOCKGROUP = suggestion.item.GROUPCODE;

      var cari = {
        ACTNAME: this.ACTNAME,
        ACTID: this.ACTID
      };
      this.setData(this.ACTNAME);
      this.$store.commit("account/SATINALMA_CARI", this.ACTID);
      this.$root.$emit("satinalmaPlanlamaListForACT",this.params.rowIndex, suggestion.item, this.params.data.STOCKID, this.params.data.GROUPCODE);

      //this.params.api.stopEditing();

      // if(suggestion)
      //   this.isDisabled = false;
      return suggestion.item.ACTNAME;
    },
    
    onInputChange(text) {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        ARANAN: text
      };

      soap.createClient(url, function(err, client) {
        client.INT_Ls_Act_ActSec(args, function(err, result) {
          if (result.INT_Ls_Act_ActSecResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }

          vm.veriler = JSON.parse(result.INT_Ls_Act_ActSecResult);
          vm.datasuggest = vm.veriler;

          if (text === "" || text === undefined) {
            vm.isDisabled = true;
            return;
          }
          vm.filteredOptions = [
            {
              data: vm.datasuggest.filter(option => {
                return (
                  option.ACTNAME.toLowerCase().indexOf(vm.query.toLowerCase()) >
                  -1
                );
              })
            }
          ];
        });
      });
    }
  }
};
</script>
